import { render, staticRenderFns } from "./EditSectionPage.vue?vue&type=template&id=57e012e7"
import script from "./EditSectionPage.vue?vue&type=script&lang=js"
export * from "./EditSectionPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports